import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const footerDefaultVariants = {}
const footerCompoundVariants = []

const footerSlotNames = [
  [
    "root",
    "footer__root"
  ],
  [
    "contentWrapper",
    "footer__contentWrapper"
  ],
  [
    "logoWrapper",
    "footer__logoWrapper"
  ],
  [
    "policyWrapper",
    "footer__policyWrapper"
  ],
  [
    "contactGrid",
    "footer__contactGrid"
  ],
  [
    "actionGrid",
    "footer__actionGrid"
  ],
  [
    "content",
    "footer__content"
  ],
  [
    "menu",
    "footer__menu"
  ],
  [
    "policy",
    "footer__policy"
  ],
  [
    "title",
    "footer__title"
  ],
  [
    "titleApp",
    "footer__titleApp"
  ],
  [
    "link",
    "footer__link"
  ],
  [
    "linkImg",
    "footer__linkImg"
  ],
  [
    "gridLogoDownload",
    "footer__gridLogoDownload"
  ],
  [
    "gridLogoMenu",
    "footer__gridLogoMenu"
  ]
]
const footerSlotFns = /* @__PURE__ */ footerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, footerDefaultVariants, getSlotCompoundVariant(footerCompoundVariants, slotName))])

const footerFn = memo((props = {}) => {
  return Object.fromEntries(footerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const footerVariantKeys = []
const getVariantProps = (variants) => ({ ...footerDefaultVariants, ...compact(variants) })

export const footer = /* @__PURE__ */ Object.assign(footerFn, {
  __recipe__: false,
  __name__: 'footer',
  raw: (props) => props,
  variantKeys: footerVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, footerVariantKeys)
  },
  getVariantProps
})